import React from "react";
import "bootstrap/dist/js/bootstrap.bundle.min";

const MainsSyllabusMain = () => {
  return (
    <div className="container my-5" style={{ paddingBottom: "70px" }}>
      <div className="accordion" id="mainsSyllabusAccordion">
        {/* Essay & Qualifying Papers */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingSix">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="true"
              aria-controls="collapseSix"
            >
              Qualifying Papers (English & any Indian Language)
            </button>
          </h2>
          <div
            id="collapseSix"
            className="accordion-collapse collapse show"
            aria-labelledby="headingSix"
            data-bs-parent="#mainsSyllabusAccordion"
          >
            <div className="accordion-body">
              <ul style={{ listStyleType: "disc", paddingLeft: "30px" }}>
                <li>
                  <b>Reading Comprehension</b> – Understanding and interpreting
                  given passages.
                </li>
                <li>
                  <b>Summarization</b> – Writing a précis based on the provided
                  content.
                </li>
                <li>
                  <b> Language Proficiency</b> – Application of grammar,
                  vocabulary, and correct usage.
                </li>
                <li>
                  <b>Essay Writing</b> – Crafting short essays on given topics.
                </li>
                <li>
                  <b>Translation Skills</b> – Converting text between English
                  and the selected Indian language.
                </li>
              </ul>
              <p style={{ marginTop: "10px" }}>
                <strong>Important Note</strong>
                <br />
                The Indian Language and English papers, set at the Matriculation
                or equivalent level, are purely qualifying in nature and will
                not affect the final ranking, with candidates required to
                attempt them in their respective languages except for
                translation sections.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="mainsSyllabusAccordion">
        {/* Essay & Qualifying Papers */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingFive">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Essay
            </button>
          </h2>
          <div
            id="collapseFive"
            className="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#mainsSyllabusAccordion"
          >
            <div className="accordion-body">
              <p>
                Candidates may need to write essays on multiple topics, adhering
                closely to the subject while organizing their ideas in a
                structured manner and maintaining conciseness.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="mainsSyllabusAccordion">
        {/* General Studies - I */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              General Studies - I (Indian Heritage, History & Geography)
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="headingOne"
            data-bs-parent="#mainsSyllabusAccordion"
          >
            <div className="accordion-body">
              <ol type="i">
                <li>
                  Indian Culture - Art Forms, Literature, and Architecture.
                </li>
                <li>Modern Indian History from mid-18th century to present.</li>
                <li>Freedom Struggle and major contributors.</li>
                <li>Post-independence consolidation and reorganization.</li>
                <li>
                  World History - Industrial Revolution, World Wars, Political
                  Philosophies.
                </li>
                <li>Salient features of Indian Society, Diversity of India.</li>
                <li>
                  Effects of Globalization, Social Empowerment, Communalism,
                  Regionalism & Secularism.
                </li>
                <li>
                  World's Physical Geography, Natural Resources, Geophysical
                  Phenomena.
                </li>
              </ol>
            </div>
          </div>
        </div>

        {/* General Studies - II */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              General Studies - II (Governance, Polity & International
              Relations)
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#mainsSyllabusAccordion"
          >
            <div className="accordion-body">
              <ol type="i">
                <li>
                  Indian Constitution - Evolution, Features, Amendments, Basic
                  Structure.
                </li>
                <li>
                  Union and State Government functions, Federal Structure.
                </li>
                <li>Separation of Powers, Dispute Redressal Mechanisms.</li>
                <li>Comparison of Indian Constitution with other countries.</li>
                <li>Parliament, State Legislatures, Executive & Judiciary.</li>
                <li>
                  Government Policies, Welfare Schemes, Development Industry.
                </li>
                <li>
                  International Relations, India’s Neighborhood & Global
                  Influence.
                </li>
                <li>Important International Organizations and Agreements.</li>
              </ol>
            </div>
          </div>
        </div>

        {/* General Studies - III */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingThree">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              General Studies - III (Economy, Science, Environment & Security)
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#mainsSyllabusAccordion"
          >
            <div className="accordion-body">
              <ol type="i">
                <li>Indian Economy, Growth, Development, Employment.</li>
                <li>Agriculture, Irrigation, Food Security, Farm Subsidies.</li>
                <li>Infrastructure: Energy, Transport, Investment Models.</li>
                <li>Science & Technology Developments, Indigenization.</li>
                <li>Environmental Conservation, Disaster Management.</li>
                <li>Internal Security, Role of Media & Cybersecurity.</li>
                <li>Border Security, Organized Crime & Terrorism.</li>
              </ol>
            </div>
          </div>
        </div>

        {/* General Studies - IV */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingFour">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              General Studies - IV (Ethics, Integrity & Aptitude)
            </button>
          </h2>
          <div
            id="collapseFour"
            className="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#mainsSyllabusAccordion"
          >
            <div className="accordion-body">
              <ol type="i">
                <li>Ethics and Human Interface, Moral Values.</li>
                <li>Attitude: Moral & Political, Social Influence.</li>
                <li>Aptitude, Foundational Values for Civil Services.</li>
                <li>Emotional Intelligence & its Applications.</li>
                <li>Contributions of Indian & World Philosophers.</li>
                <li>Ethics in Public Administration, Governance, Probity.</li>
                <li>Case Studies on Ethics & Public Service Values.</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Optional subjects */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingSeven">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseSeven"
            >
              Optional Subjects
            </button>
          </h2>
          <div
            id="collapseSeven"
            className="accordion-collapse collapse"
            aria-labelledby="headingSeven"
            data-bs-parent="#mainsSyllabusAccordion"
          >
            <div className="accordion-body">
              <p>
                <b>Essay Type Questions | Duration: 3 Hours</b>
              </p>

              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <thead class="thead-dark"></thead>
                  <tbody>
                    <tr>
                      <td>Agriculture</td>
                      <td>Geography</td>
                      <td>Philosophy</td>
                    </tr>
                    <tr>
                      <td>Animal Husbandry and Veterinary Science</td>
                      <td>Geology</td>
                      <td>Physics</td>
                    </tr>
                    <tr>
                      <td>Anthropology</td>
                      <td>History</td>
                      <td>Political Science and International Relations</td>
                    </tr>
                    <tr>
                      <td>Botany</td>
                      <td>Law</td>
                      <td>Psychology</td>
                    </tr>
                    <tr>
                      <td>Chemistry</td>
                      <td>Management</td>
                      <td>Public Administration</td>
                    </tr>
                    <tr>
                      <td>Civil Engineering</td>
                      <td>Mathematics</td>
                      <td>Sociology</td>
                    </tr>
                    <tr>
                      <td>Commerce and Accountancy</td>
                      <td>Mechanical Engineering</td>
                      <td>Statistics</td>
                    </tr>
                    <tr>
                      <td>Economics</td>
                      <td>Medical Science</td>
                      <td>Zoology</td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <strong>
                          Literature (Any one of the following languages):
                        </strong>
                        <br />
                        Assamese, Bengali, Bodo, Dogri, Gujarati, Hindi,
                        Kannada, Kashmiri, Konkani, Maithili, Malayalam,
                        Manipuri, Marathi, Nepali, Odia, Punjabi, Sanskrit,
                        Santhali, Sindhi, Tamil, Telugu, Urdu, English.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainsSyllabusMain;
